import React from 'react';
type IncludedTagProps = {
  /** Valore di riferimento del bonus, mostrato barrato. */
  referencePrice?: string;
};
export function IncludedTag({
  referencePrice = '10 €'
}: IncludedTagProps) {
  return <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5" data-id="element-127" data-mp="7p3uybtmzemr">
      <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-mint-soft px-3 py-1 text-sm font-bold text-mint" data-id="element-128" data-mp="2qsl413cd44j">
        <s className="font-medium text-ink/55" aria-label={`Prezzo precedente ${referencePrice}`} data-id="element-129" data-mp="zg07fbbsbh9i">
          {referencePrice}
        </s>
        <span aria-label="Ora 0 €" data-id="element-130" data-mp="vhkphluk8z2y">0 €</span>
      </span>
      <span className="text-sm text-ink/70" data-id="element-131" data-mp="qnyd7usb6x7o">Incluso nel pack</span>
    </div>;
}